import { Badge, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import FernieMicro from "~/components/fernie/FernieMicro";
import { PHONE_SQUARE_TOUCH_TARGET_SX } from "~/components/mobile/bottomNav/mobileBottomNav";
import { FeatureFlagName } from "~/gql/graphqlBase.generated";
import useFeatureFlag from "~/hooks/useFeatureFlag";
import useHasChatHistory from "~/hooks/useHasChatHistory";
import runGuardedExit from "~/layout/unsavedChangesRegistry";
import { MOBILE_FERNIE_PATH } from "~mobile/fernie/fernieRoute";

const MobileFernieLauncher = () => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();
	const { isEnabled: isAiChatEnabled } = useFeatureFlag(FeatureFlagName.AiChat);
	const hasChatHistory = useHasChatHistory();

	if (!isAiChatEnabled) return null;

	return (
		<Tooltip title={hasChatHistory ? t("search.fernieWithHistory") : t("search.fernie")}>
			<IconButton
				aria-label="open fernie"
				onClick={() => runGuardedExit(() => navigate(MOBILE_FERNIE_PATH))}
				size="small"
				sx={[{ flexShrink: 0 }, PHONE_SQUARE_TOUCH_TARGET_SX]}
			>
				<Badge
					color="primary"
					invisible={!hasChatHistory}
					overlap="circular"
					sx={{ "& .MuiBadge-badge": { height: 8, minWidth: 8 } }}
					variant="dot"
				>
					<FernieMicro size={22} variant="smile" />
				</Badge>
			</IconButton>
		</Tooltip>
	);
};

export default MobileFernieLauncher;
